import { z } from 'zod';
import { PaginationMeta, PaginationMetaSchema } from '@/types/pagination-meta.ts';
import { DealerStatus } from '@/types/dealer/dealer-status.type.ts';

export type DealerListItem = {
    id: number,
    sap_code: string,
    name: string,
    legal_entity_name?: string | null,
    holding_name?: string | null,
    city_name?: string,
    is_hyundai_dealer: boolean,
    is_genesis_dealer: boolean,
    site: string | null,
    status?: DealerStatus,
};

export type DealerPaginatorItem = DealerListItem;

export type DealersPaginator = {
    data: DealerPaginatorItem[],
    meta: PaginationMeta,
};

export type DealersRequestFilter = {
    page?: number,
    name?: string,
    sap_code?: string,
    holding_id?: number[],
    is_hyundai_dealer?: 0 | 1,
    is_genesis_dealer?: 0 | 1,
    status?: DealerStatus[],
    sort?: Record<string, string>[],
};

export const DealerListItemSchema = z.object({
    id: z.number(),
    sap_code: z.string(),
    name: z.string(),
    legal_entity_name: z.string().nullable().optional(),
    holding_name: z.string().nullable().optional(),
    city_name: z.string().optional(),
    is_hyundai_dealer: z.boolean(),
    is_genesis_dealer: z.boolean(),
    site: z.string().nullable(),
    status: z.nativeEnum(DealerStatus).optional(),
});

// export const DealerPaginatorItemSchema = DealerListItemSchema;

export const DealerPaginatorSchema = z.object({
    data: z.array(DealerListItemSchema),
    meta: PaginationMetaSchema,
});

export const DealersSchema = z.array(DealerListItemSchema);
